import { useQuery } from 'query';

import { loadSummary } from '../sources/loadSummary';
import { summary } from './queryKeyFactory';

export const useSummary = (params: any) => {
  return useQuery(summary(params), async () => {
    return loadSummary(params);
  });
};
